import jQuery from 'jquery';
import * as slickGallery from './slick-gallery';

let firstRun = true;

function getDaysInMonth(month, year) {
    const date = new Date(year, month, 1);
    const days = [];
    while (date.getMonth() === month) {
        days.push(new Date(date));
        date.setDate(date.getDate() + 1);
    }
    return days;
}

const isToday = (someDate) => {
    const today = new Date();
    return someDate.getDate() === today.getDate() &&
        someDate.getMonth() === today.getMonth() &&
        someDate.getFullYear() === today.getFullYear();
};

function generateCalendar(date) {
    const currentYear = date.getFullYear();
    const currentMonth = date.getMonth();

    let currentDay = null;

    const daysInCurrentMonth = getDaysInMonth(currentMonth, currentYear);

    const selector = jQuery('.event-calendar__days .content .event-calendar-days-content');

    const options = { weekday: 'short' };

    let newItems = '';

    daysInCurrentMonth.forEach((day) => {
        const dayNumber = day.getDate();
        const dayName = day.toLocaleDateString(window.navigator.language, options).replace(/\./g, '');

        newItems += `
            <a href="#" class="event-calendar__day ${isToday(day) ? 'today' : ''}" data-day="${dayNumber}">
                <div>${dayName}</div>
                <div>${dayNumber}</div>
            </a>
        `;

        if (isToday(day)) { currentDay = dayNumber; }
    });

    jQuery(selector).parent().addClass('wait');

    setTimeout(() => {
        if (!firstRun) {
            jQuery(selector).slick('unslick');
            jQuery(selector).removeClass('slick-slider');
        }

        jQuery(selector).html(newItems);

        slickGallery.days(currentDay);

        setTimeout(() => { jQuery(selector).parent().removeClass('wait'); }, 200);

        firstRun = false;
    }, 200);
}

function jsUcfirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function setMonth(date) {
    const currentYear = date.getFullYear();
    const currentMonthName = jsUcfirst(date.toLocaleString(window.navigator.language, { month: 'long' }));

    const selector = jQuery('.event-calendar-filters__current-month');

    jQuery(selector).html(`
        <span>${currentMonthName} ${currentYear}</span>
    `);

    generateCalendar(date);
}

const calendarDate = new Date();

export default function listenForClicks() {
    jQuery(() => {
        jQuery('.event-calendar-filters__arrow').on('click', function () {
            // previous
            if (jQuery(this).hasClass('previous')) {
                calendarDate.setMonth(calendarDate.getMonth() - 1);
            } else {
                // next
                calendarDate.setMonth(calendarDate.getMonth() + 1);
            }
            setMonth(calendarDate);
        });

        jQuery('body').on('click', '.event-calendar__days .slick-slide .event-calendar__day', function (e) {
            e.preventDefault();

            const date = `${jQuery(this).data('day')}-${calendarDate.getMonth() + 1}-${calendarDate.getFullYear()}`;
            jQuery('input[name=date]').val(date);

            jQuery('.event-calendar__days .slick-slide .event-calendar__day').removeClass('current');
            jQuery(this).addClass('current');

            submitSearchApartmensForm(100);
        });

        setMonth(calendarDate);
        submitSearchApartmensForm(100);
    });


    const scrollOffset = 150;
    const calendarResultsContainer = jQuery('.events-boxes');
    const calendarForm = jQuery('#calendar-form');

    function generateEvents(data) {
        const markup = data.map((event) => {
            let dateString = '';

            if (event.startDate) {
                dateString = event.startDate;
            }
            if (event.endDate && event.endDate !== event.startDate) {
                if (event.startDate) {
                    dateString += ' - ';
                }
                dateString += event.endDate;
            }

            return `
                <article class="events-box col-md-4">
                    <a href="${event.path || '#'}">
                        <div class="events-box__img">
                            ${event.list_img_url !== null ?
        `<img src="${event.list_img_url}" alt="${event.list_img_alt ? event.list_img_alt : ''}" />` :
        '<img src="data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw==" alt="" />'
}
                        </div>

                        <div class="events-box__description">
                            <div class="events-box__caption">
                                <h3>${event.name || ''}</h3>
                            </div>
                            
                            ${event.places ? `
                                <div class="events-box__place">
                                
                                    ${event.places.map((place) => `
                                        ${place.name !== '' ? `
                                            <p>
                                                ${place.name}
                                                ${place.address !== '' ? ` <span class="events-box__address">${place.address}</span>` : ''}
                                            </p>
                                        ` : ''}
                                       
                                    `).join('')}
                                </div>
                            ` : ''}
                        </div>

                        <div class="events-box__date">
                            <time datetime="${dateString}">${dateString}</time>
                        </div>

                    </a>
                </article>
            `;
        });

        jQuery(calendarResultsContainer).html(markup);
    }

    jQuery(calendarForm).submit((event) => {
        event.preventDefault();

        const formData = jQuery(calendarForm).serialize();

        jQuery.ajax({
            type: jQuery(calendarForm).attr('method') ? jQuery(calendarForm).attr('method') : 'GET',
            url: jQuery(calendarForm).attr('action'),
            data: formData,
            beforeSend() {
                jQuery(calendarResultsContainer).addClass('loading');
            },
        }).done((response) => {
            jQuery(calendarResultsContainer).removeClass('loading');

            if (response.events.length) {
                generateEvents(response.events);
            } else {
                jQuery(calendarResultsContainer).html(`
                    <div class="info-box">
                        ${jQuery('.message__no-items').html()}
                    </div>
                `);
            }

            if (jQuery(window).scrollTop() > jQuery(calendarResultsContainer).offset().top) {
                jQuery([document.documentElement, document.body]).animate({
                    scrollTop: jQuery(calendarResultsContainer).offset().top - scrollOffset,
                }, 300);
            }
        }).fail((response) => {
            jQuery(calendarResultsContainer).removeClass('loading');
            alert(response);
        });
    });

    let timer;
    function submitSearchApartmensForm(timeout) {
        if (timer) { clearTimeout(timer); }
        timer = setTimeout(() => {
            jQuery(calendarForm).submit();
        }, timeout);
    }
    // submit on input change
    jQuery('#calendar-form input, #calendar-form select').change(() => {
        submitSearchApartmensForm(1000);
    });
    // submit on input edit
    jQuery('#calendar-form input').on('input', () => {
        submitSearchApartmensForm(2500);
    });
    // submit on pagination click
    jQuery('.apartments-pagination').on('click', 'a', function (e) {
        e.preventDefault();
        submitSearchApartmensForm(0, jQuery(this).data('page'));
    });
}
